import { DataGridItem } from '../../../core/component'
import { Identity, Nullable } from '../../../core/type'
import { SortItem } from '../../../core/component/Search'

export interface ItemCategory extends Identity {
  title: string
  level: ItemCategoryLevel
  parent: ItemCategory
}

export type ItemCategoryListItem  = ItemCategory & DataGridItem & {
  used: number
}

export interface ItemCategoryEntry extends DataGridItem, Omit<ItemCategory, 'createdAt'
  | 'updatedAt'> {
}

export interface ItemCategoryDto {
  title: string
  parentId: Nullable<number>
}

export interface ItemCategoryFindRequest {
  ids?: number[]
  id?: number
  title?: string
  level?: ItemCategoryLevel
  parentId?: number
  /**
   * Backend filters to categories that have at least one inventory_item of
   * this product type at the requested `level`. Requires `level` to be set.
   */
  productType?: string
}
export type ItemCategoryListFindRequest = ItemCategoryFindRequest & {
  sort?: SortItem[]
}

export enum ItemCategoryLevel {
  Category = 'Category',
  Subcategory = 'Subcategory',
  Subcategory2 = 'Subcategory2',
}
